import { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '@uidotdev/usehooks';
import dayjs from 'dayjs';

import { useDictionary } from 'common/state';

const isLanguageValid = (language) => {
  return ['pt', 'en', 'es', 'no'].includes(language);
};

function LanguageWrapper({ children }) {
  const { language: paramLanguage } = useParams();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [storedLanguage, setStoredLanguage] =
    useLocalStorage('letroso-language');
  const [, dictionaryActions] = useDictionary();

  const getPreferredLanguage = () => {
    const browserLanguages = navigator.languages;
    const availableLanguages = ['no'];
    for (const browserLanguage of browserLanguages) {
      for (const availableLanguage of availableLanguages) {
        if (browserLanguage.includes(availableLanguage)) {
          return availableLanguage;
        }
      }
    }
    return 'no';
  };

  useEffect(() => {
    const newLanguage =
      (isLanguageValid(paramLanguage) && paramLanguage) ||
      storedLanguage ||
      getPreferredLanguage();
    if (!paramLanguage || !isLanguageValid(paramLanguage)) {
      navigate(`/${newLanguage}${pathname}${search}`, {
        replace: true,
      });
      return;
    }
    i18n.changeLanguage(newLanguage);
    dayjs.locale(newLanguage);
    setStoredLanguage(newLanguage);
    let langCode = '';
    if (newLanguage === 'pt') {
      langCode = 'pt-BR';
    } else if (newLanguage === 'en') {
      langCode = 'en-US';
    } else if (newLanguage === 'no') {
      langCode = 'no-NO';
    } else {
      langCode = 'es-ES';
    }
    document.documentElement.lang = langCode;
    dictionaryActions.load(newLanguage);
  }, [paramLanguage]); // eslint-disable-line react-hooks/exhaustive-deps

  return children;
}

export default LanguageWrapper;
